import {
  Connection,
  ContractStatus,
  ContractDirection,
} from '../../../../types/responses/Interoperability';

/**
 * Filtro da lista de conexões.
 *
 * No cliente porque o endpoint devolve todos os contratos da conta, já agrupados por
 * hierarquia do parceiro. Com o conjunto completo em mãos, filtrar aqui dá o mesmo resultado
 * que no servidor — e agrupar no servidor e filtrar depois seria refazer o agrupamento.
 */

export type ConnectionFilter = {
  /** Busca por nome ou alias do parceiro. */
  search: string;

  status: ContractStatus | '';
  contractType: ContractDirection | '';

  /**
   * Só os contratos de quem recebe estação.
   *
   * É a pergunta que aparece na operação: "de quem eu estou exibindo estação hoje?". Sem
   * isto, quem tem dezenas de contratos precisa ler a coluna linha por linha.
   */
  onlyReceiving: boolean;
};

export const EMPTY_CONNECTION_FILTER: ConnectionFilter = {
  search: '',
  status: '',
  contractType: '',
  onlyReceiving: false,
};

const matchesSearch = (connection: Connection, search: string): boolean => {
  const term = search.trim().toLowerCase();

  if (!term) {
    return true;
  }

  // Nome e alias: o alias é como o parceiro aparece na URL do logo e em conversa técnica.
  return [connection.partner_name, connection.partner_alias]
    .filter((field): field is string => !!field)
    .some((field) => field.toLowerCase().includes(term));
};

export const filterConnections = (
  connections: Connection[],
  filter: ConnectionFilter,
): Connection[] =>
  connections.filter((connection) => {
    if (!matchesSearch(connection, filter.search)) {
      return false;
    }

    if (filter.status && connection.status !== filter.status) {
      return false;
    }

    if (filter.contractType && connection.contract_type !== filter.contractType) {
      return false;
    }

    // Recebe de fato: tem estação vinda do parceiro. Contrato bidirecional com zero estação
    // do outro lado não conta, porque na prática não se recebe nada.
    if (filter.onlyReceiving && !connection.received_station_count) {
      return false;
    }

    return true;
  });
